import { TextButtonProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: TextButtonProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as TextButtonProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      children: 'Text Button',
    } as TextButtonProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
